// @flow

import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import TopLevelNavLink from './TopLevelNavLink';
import type { NavLinkType } from '../types';
import styles from './MenuListItem.less';

type Props = {|
  /** Data model for the link */
  link: NavLinkType,
  /** Where link has sub link */
  hasSubItem?: boolean,
|};

const MenuListItem = (props: Props) => (
  <li>
    <TopLevelNavLink
      link={props.link}
      extraClasses={styles.menuListItem}
      key={`${props.link.id}_${props.link.text}`}
      extraLabel={
        props.hasSubItem ? (
          <Icon className={styles.subItemIndicator} name="single-chevron-right" />
        ) : null
      }
      nonLink={props.link.id === 'tourism' || props.link.id === 'scoped-home'}
    />
  </li>
);

export default MenuListItem;
